import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import bootstrap from 'bootstrap';
import VueQr from 'vue-qr';
import VueApexCharts from 'vue-apexcharts';
import Cookies from 'js-cookie';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';

import $ from 'jquery';
require('./assets/js/tabler.min.js');

import App from './App.vue';
import router from './router';

import IndexLayout from './components/layouts/index';
import MerchantLayout from './components/layouts/merchant';

Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
Vue.use(VueApexCharts);
Vue.use(VueMoment, {
  moment,
});

Vue.component('apexchart', VueApexCharts);
Vue.component('index-layout', IndexLayout);
Vue.component('merchant-layout', MerchantLayout);

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');

router.beforeEach(async (to, from, next) => {
  if (to.meta.requiresAuth) {
    try {
      const token = Cookies.get('USD2PayToken');
      const api = `${process.env.VUE_APP_API_URL}/api/${process.env.VUE_APP_API_VERSION}/merchant/me`;
      await axios.get(api, { headers: { Authorization: `Bearer ${token}` } });
      next();
    } catch (err) {
      next({
        path: '/login',
      });
    }
  } else {
    next();
  }
});
